import { updateObject } from 'utils/updateObject'
import {
  ACCOUNTS_CONNECTED_FETCH_END,
  ACCOUNTS_CONNECTED_FETCH_FAIL,
  ACCOUNTS_CONNECTED_FETCH_START,
  DELETE_ACCOUNT_FETCH_END,
  DELETE_ACCOUNT_FETCH_FAIL,
  DELETE_ACCOUNT_FETCH_START,
  SET_ACCOUNTS_CONNECTED,
} from './types'

const initialState = {
  loading: false,
  loadFailed: false,
}

const setAccounts = (state, { payload }) =>
  updateObject(state, {
    accounts: payload,
  })

const setLoading = (state) =>
  updateObject(state, {
    loading: true,
    loadFailed: false,
  })

const setLoadingFail = (state) =>
  updateObject(state, {
    loading: false,
    loadFailed: true,
  })

const setLoadingEnd = (state) =>
  updateObject(state, {
    loading: false,
    loadFailed: false,
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNTS_CONNECTED_FETCH_START:
      return setLoading(state)

    case SET_ACCOUNTS_CONNECTED:
      return setAccounts(state, action)

    case ACCOUNTS_CONNECTED_FETCH_FAIL:
      return setLoadingFail(state)

    case ACCOUNTS_CONNECTED_FETCH_END:
      return setLoadingEnd(state)

    case DELETE_ACCOUNT_FETCH_START:
      return setLoading(state)

    case DELETE_ACCOUNT_FETCH_FAIL:
      return setLoadingFail(state)

    case DELETE_ACCOUNT_FETCH_END:
      return setLoadingEnd(state)

    default:
      return state
  }
}

export default reducer
